module.exports = __webpack_public_path__ + "static/logo-ptpn-8-5d0b4d45733117a3151b32acaafa1002.png";